var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrateMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 3281.0933,
    height: 3078.0933,
    viewBox: "0 0 3281.0933 3078.0933",
    sodipodidocname: "celebration.eps",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeshowpageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0,
    inkscapedeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,3078.0933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 17155.7,4782.4 c 0,0 -511.1,1358.5 1110,4060.2 0,0 -520.3,433.6 -794.7,490.4 0,0 -2489.3,-2894.1 -3053.7,-6922.3 L 14387.5,1108.8 18323.9,0 v 0 c 891.5,673.402 1769.8,1347.4 2580.5,2091.7 852.9,783 1591.2,1682.3 2199.2,2667.6 l 513.1,831.5 c 0,0 -393.6,433.6 -764.2,471.5 0,0 -1196.8,-1658.7 -2710.5,-2519.5 -1513.6,-860.7 -2986.3,1239.6 -2986.3,1239.6",
    style: {
      fill: "#bccef8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18943.7,3122 c -215.2,-348.8 -791.2,-383.8 -1286.5,-78.1 -495.3,305.6 -722.3,836.1 -507.1,1184.9 215.3,348.8 791.2,383.8 1286.5,78.1 495.3,-305.6 722.3,-836.1 507.1,-1184.9",
    style: {
      fill: "#cfb997",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18473.9,2716.8 c -100,-162.2 -539.9,-136.1 -947.4,115.3 -407.4,251.4 -628,632.9 -527.9,795 0,0 -55.3,-332 585.3,-727.2 592.3,-365.5 890,-183.1 890,-183.1",
    style: {
      fill: "#a2b5bb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17228.2,4116.4 c 0,0 -443,552.2 81.9,1633.5 0,0 -41.7,391.6 358.2,866.5 481.2,571.4 1451.7,713.1 2207.7,-82.3 175.7,-184.9 162.6,-390.2 413.1,-650.5 0,0 973.2,-312.7 138.3,-1665.7 -598.1,-969.3 -1587.9,-1086.5 -1587.9,-1086.5 -274.1,611 -1611.3,985 -1611.3,985",
    style: {
      fill: "#ffdb91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19816.8,3847.7 c -263.6,-427.3 -1201.6,-1258.1 -2087.2,-711.6 -908,560.3 -563.6,1757.4 -300,2184.6 527.3,854.6 1489.2,1217.6 2148.4,810.8 659.2,-406.8 766.1,-1429.3 238.8,-2283.8",
    style: {
      fill: "#ffc59d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19770.3,3772.2 c 0,0 357.5,667.2 -870.2,1471.6 0,0 -146.1,750.9 784.4,1060.3 0,0 1406.5,-733.3 85.8,-2531.9",
    style: {
      fill: "#ffdb91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19097.3,5352.6 c 0,0 621.8,-886 593.3,-881.6 -1036.8,162.8 -1112.2,1276.2 -2302.4,771.1 0,0 450.6,1945.1 2296.3,1062 0,0 9.9,-424.7 -587.2,-951.5",
    style: {
      fill: "#ffdb91",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19158.9,9740.6 -10,-1.9 c -151.7,-28.5 -307,-32.8 -460,-12.6 v 0 0 c 74.6,262.5 174.2,517.3 297.2,760.8 l 5.6,11.2 c 15,37.4 -33.7,67.3 -61.1,37.7 v 0 c -178.5,-163 -341.7,-342 -487.5,-534.9 l -43.2,-57.2 v 0 c 22.8,249.8 66.1,497.3 129.6,740 l 21.1,80.5 c 7.2,42.7 -47.7,62.2 -70.6,25.2 v 0 c -173.9,-216.8 -322.3,-452.8 -442.4,-703.4 l -29.2,-60.9 v 0 c -33.7,193.5 -44.9,390.3 -33.5,586.4 l 5.8,99.2 c -1.7,43 -60.6,49 -74,7.6 l -35.6,-85.8 c -83.3,-201.2 -384.4,-839.3 -400.1,-1299.5 -8,-232.1 165.2,-425.8 255.4,-481.4 130.4,-80.4 373.4,-88.9 542.3,-10.8 0,0 166.6,202 353.5,328.7 197,133.5 383.8,281.7 544,457.8 l 25.8,28.3 c 36.1,31.5 13.3,90 -33.1,85",
    style: {
      fill: "#ffc59d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23188.4,7102.8 2.3,-10 c 34.3,-151.8 92.5,-297.2 172.3,-430.8 v 0 0 c 213,174 409,368 585.2,579.3 l 8,9.6 c 28.7,28.8 75.8,-4.3 59.4,-41.4 v 0 c -79.4,-230.4 -179.8,-453 -300,-665 l -35.7,-62.8 v 0 c 222.1,120.9 433.7,259.9 632.9,415.7 l 66.1,51.7 c 36.6,23.8 76.7,-19.2 51.5,-55.2 v 0 c -131.1,-247.6 -290.1,-479.3 -473.9,-690.6 l -44.7,-51.4 v 0 c 192.5,46.2 379.1,114.5 555.9,203.5 l 89.6,45.1 c 40.4,15.5 69.5,-36.6 36.6,-65.5 l -65.2,-67.3 c -152.8,-157.5 -622.9,-691.2 -1042.4,-889.8 -211.6,-100.2 -460.1,-17.3 -547.7,43.9 -126.5,88.4 -231.5,309.9 -226.8,497.4 0,0 120.3,235 162.8,458.6 44.8,235.7 107.2,467.7 206.1,686.4 l 15.9,35.2 c 14.7,46 78,48.3 91.8,3.4",
    style: {
      fill: "#ffc59d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18268.7,8840.8 -2.1,-5.8 c -48.9,-136.7 -151.8,-465.6 -241.1,-410.6 -147.1,90.8 -473.4,299.4 -281.3,776.7 0,0 378.8,-186 524.5,-360.3",
    style: {
      fill: "#bec4ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17471,9333 -4.3,-4.4 c -100.2,-105.1 -213.3,-197.1 -336.4,-273.9 v 0 c -24.7,-20.2 -23.5,-58.3 2.4,-76.8 140.8,-100.3 555,-337.8 895.5,48 0,0 -336.1,255.1 -557.2,307.1",
    style: {
      fill: "#c6cecc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23524.5,5396 -2.6,-5.8 c -62.2,-137.9 -106.8,-283 -132.8,-431.9 v 0 c -9.8,-31.7 -47,-45.5 -75,-27.7 -152,96.7 -543.2,403.6 -304,883.1 0,0 377.7,-224.6 514.4,-417.7",
    style: {
      fill: "#bec4ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22737.3,5973.4 -4.7,-4.2 c -112.8,-100.7 -354,-355.2 -266,-419.8 145.2,-106.5 438.1,-313.4 823.7,58.8 0,0 -327.7,292.8 -553,365.2",
    style: {
      fill: "#c6cecc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5139.98,3686.1 c 0,0 -1449.18,81.6 -3265.33,2656.3 0,0 -606.86,-300.7 -769.74,-528.8 0,0 1641.27,-3446.6 5097.76,-5590.799 L 9986.51,1108.8 V 2822 C 9730.9,3909.6 9469.31,4985.3 9116.13,6027.7 8744.61,7124.3 8220.43,8163 7564.89,9117.4 l -553.18,805.3 c 0,0 -555.7,-184.8 -740.13,-508.4 0,0 1033.46,-1765.1 1209.09,-3497.5 C 7656.3,4184.4 5139.98,3686.1 5139.98,3686.1",
    style: {
      fill: "#b5ebc5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7381.31,4650.6 c 232.05,-337.8 31.29,-878.8 -448.43,-1208.3 -479.71,-329.5 -1056.72,-322.8 -1288.77,15 -232.06,337.8 -31.29,878.8 448.42,1208.4 479.72,329.5 1056.72,322.7 1288.78,-15.1",
    style: {
      fill: "#cfb997",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7562.14,4057.1 c 107.91,-157.1 -93.75,-548.9 -488.35,-819.9 -394.6,-271.1 -832.72,-318.7 -940.63,-161.6 0,0 281.4,-184.8 901.79,241.4 573.68,394.1 527.19,740.1 527.19,740.1",
    style: {
      fill: "#a2b5bb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5778.47,3483.3 c 0,0 -396.35,-119.9 -823.69,148.8 -201.75,126.9 -219.05,296.6 -380.67,376.8 -83.77,41.6 -209.88,34.2 -347.24,201.3 -138.55,168.5 -5.59,266.1 -93.3,346.3 -489.83,447.4 -174.29,510.2 -269.24,824.1 -106.69,352.6 83.07,560.9 442.92,713.7 82.95,35.2 -39.74,175.9 167.77,487.7 178.05,267.4 604.14,395.6 943.27,367.1 0,0 518.99,468.1 853.13,-43.4 115.26,-176.4 496.99,-149.3 707.06,-455.1 644.89,-938.8 352.14,-1891.5 352.14,-1891.5 C 6661,4555.3 5778.47,3483.3 5778.47,3483.3",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7070.42,5742.5 c 185.27,-269.7 391.91,-1251.2 373.49,-1418.1 -32.75,-296.6 -267.42,-573.4 -566.13,-778.6 -260.16,-178.7 -626.27,-339.5 -874.49,-281.2 -404.67,95.1 -1044.88,598.2 -1245.05,889.7 -568.54,827.6 -511.83,1854.1 126.66,2292.7 638.49,438.6 1616.98,123.2 2185.52,-704.5",
    style: {
      fill: "#e7b18e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7120.61,5669.4 c 0,0 -465.79,596.7 -1697.75,-201.2 0,0 -745.83,169.8 -652.81,1146 0,0 1239.15,990.2 2350.56,-944.8",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5403.12,5692.6 c 0,0 1058.02,212.6 1046.12,186.4 -225.48,-497.2 -812.81,-290.6 -921.26,-829.9 -95.43,-474.5 -702.94,-174.6 -714.53,-964.5 0,0 -1597.08,1198.3 -43.4,2529.6 0,0 392.44,-162.6 633.07,-921.6",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1414.33,7522.3 -2.32,-9.9 c -35.28,-150.3 -94.13,-294 -174.39,-425.9 v 0 0 c -209.94,174.3 -402.768,368.4 -575.839,579.4 l -7.902,9.6 c -28.215,28.8 -75.231,-3.7 -59.211,-40.7 v 0 c 76.898,-229.1 174.727,-450.8 292.234,-662 l 34.86,-62.7 v 0 c -219.297,121.8 -428.164,261.5 -624.457,417.6 l -65.133,51.8 c -36.113,23.9 -76.234,-18.4 -51.551,-54.4 v 0 C 308.617,7078.5 464.492,6847.3 645.18,6636.2 l 43.883,-51.3 v 0 c -190.618,47.4 -375.118,116.6 -549.84,206.4 L 50.75,6836.7 C 10.7461,6852.5 -18.5391,6801 13.9219,6772 l 64.1406,-67.2 C 228.344,6547.3 690.355,6014 1104.91,5813.6 c 209.08,-101.1 456.27,-20.9 543.62,39.1 126.26,86.8 232.2,305.6 229.02,491.7 0,0 -117.43,234 -157.76,456.2 -42.49,234.1 -102.6,464.8 -198.93,682.6 l -15.49,35 c -14.17,45.7 -76.92,48.5 -91.04,4.1",
    style: {
      fill: "#e7b18e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5455.61,10142 10.05,-1.9 c 152.71,-30 309.19,-35.6 463.63,-16.5 v 0 0 c -73.08,265.2 -171.31,522.8 -293.35,769.4 l -5.57,11.2 c -14.74,37.9 34.61,67.6 61.93,37.5 v 0 c 178.63,-165.7 341.64,-347.5 486.94,-543.1 l 43.11,-58 v 0 c -20.87,251.9 -62.52,501.8 -124.54,746.9 l -20.57,81.3 c -6.95,43.1 48.59,62.4 71.36,24.8 v 0 c 173.48,-219.9 321.16,-459 440.15,-712.6 l 28.9,-61.6 v 0 c 35.57,194.8 48.52,393 38.58,590.8 l -5.03,100.1 c 2.1,43.3 61.51,48.8 74.71,7 l 35.14,-86.8 c 82.35,-203.4 380.56,-849.1 392.67,-1313.1 6.1,-234.1 -170.12,-427.9 -261.49,-483.2 -132.06,-80 -377.06,-86.6 -546.67,-6.5 0,0 -166.28,205 -353.68,334.3 -197.48,136.2 -384.47,287.1 -544.57,465.9 l -25.76,28.8 c -36.09,32 -12.62,90.8 34.06,85.3",
    style: {
      fill: "#e7b18e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1877.55,6344.4 4.47,-4.3 c 105.26,-100 364.53,-327.1 278.12,-386.4 -142.52,-97.9 -465.15,-312.1 -824.08,56.5 0,0 323.19,271.3 541.49,334.2",
    style: {
      fill: "#bec4ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1104.91,5813.6 2.36,-5.7 c 55.57,-134.1 94.07,-274.7 114.59,-418.4 v 0 c 8.46,-30.7 43.79,-45 71.18,-28.8 148.69,88.2 533.31,371.2 318.04,838.5 0,0 -369.21,-204.4 -506.17,-385.6",
    style: {
      fill: "#c6cecc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7152.58,9759.7 4.28,-4.8 c 100.95,-112.6 215.64,-212 341.39,-296 v 0 c 25.03,-21.8 22.57,-61.4 -5.03,-79.8 -149.81,-99.9 -588.66,-333.7 -930.61,78.8 0,0 358.11,254.8 589.97,301.8",
    style: {
      fill: "#bec4ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6306.27,9273 1.98,-6.1 c 46.53,-143.9 181.81,-467.3 276.46,-412.9 156.11,89.8 463.73,274.1 279.14,777.1 0,0 -400.31,-181.3 -557.58,-358.1",
    style: {
      fill: "#c6cecc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10380.5,6216.9 c 0,0 -863.99,1872.7 -672.44,3524.9 0,0 -670.44,95.8 -933.84,0 0,0 -790.17,-6015.1 1036.43,-8633 h 4590.55 c 0,0 -57,1575.5 672.5,2829.6 1054.8,1813.2 895.9,5846 895.9,5846 0,0 -562.7,162.3 -898,0 0,0 -147.5,-2040.1 -983.6,-3567.5 -836.1,-1527.4 -3707.5,0 -3707.5,0",
    style: {
      fill: "#f39189",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13289.2,5229.5 c 0,-409.8 -471.8,-742.1 -1053.8,-742.1 -582,0 -1053.8,332.3 -1053.8,742.1 0,409.9 471.8,742.1 1053.8,742.1 582,0 1053.8,-332.2 1053.8,-742.1",
    style: {
      fill: "#cfb997",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13102.2,4637.9 c 0,-190.5 -388.1,-399.3 -866.8,-399.3 -478.7,0 -866.8,208.8 -866.8,399.3 0,0 127.3,-311.6 880,-311.6 696,0 853.6,311.6 853.6,311.6",
    style: {
      fill: "#bb8082",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11307.1,5174.8 c 0,0 -991.8,-261.9 -1496.45,124 0,0 665.25,653 748.25,1692 82.9,1038.9 803,1494.1 1689.7,1335.7 0,0 1539.7,306.8 1727.7,-1385.2 188,-1692 593.7,-1692 593.7,-1692 0,0 -820.3,-442.5 -1374.4,-66.5 -554.1,376 -1888.5,-8 -1888.5,-8",
    style: {
      fill: "#603813",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13651.2,6305.6 c 0,-502.1 -701.3,-1818.2 -1402.6,-1818.2 -701.3,0 -1402.6,1316.1 -1402.6,1818.2 0,1004.1 628,1818.1 1402.6,1818.1 774.6,0 1402.6,-814 1402.6,-1818.1",
    style: {
      fill: "#fad6a5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13651.2,6216.9 c 0,0 -502.2,747.7 -1513.4,795.4 0,0 -518.6,562.2 110.8,1314.2 0,0 1582,114.6 1402.6,-2109.6",
    style: {
      fill: "#603813",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12248.6,7208.4 c 0,0 -5.6,-14.6 -18.3,-40.5 -77.9,-158.7 -423,-740 -1378.2,-951 0,0 -638,1892 1396.5,2109.6 0,0 231.4,-356.2 0,-1118.1",
    style: {
      fill: "#603813",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9996.71,10975 -7.52,-6.8 c -114.17,-103.9 -244.07,-189.1 -384.89,-252.3 v 0 0 c -74.32,262.6 -123.41,531.6 -146.59,803.6 l -1.06,12.4 c -6.96,39.7 -64.11,39.5 -71.84,0 v 0 c -66.37,-232.5 -111.21,-470.5 -133.96,-711.2 l -6.74,-71.4 h -0.01 c -111.82,224.6 -204.9,457.9 -278.28,697.8 l -24.35,79.6 c -16.25,40.1 -73.29,27.9 -73.29,-15.6 v 0 c -34.15,-275.8 -36.54,-554.6 -7.14,-830.9 l 7.14,-67.1 v 0 c -130.3,146.9 -243.18,308.5 -336.4,481.3 l -47.2,87.6 c -24.04,35.6 -77.31,9.8 -66.99,-32.5 l 14.81,-91.7 c 34.69,-214.9 113.59,-916.1 341.82,-1316 115.11,-201.7 364.26,-275.5 470.25,-275.5 153.17,0 364.4,120.4 467.12,275.5 0,0 35.71,259.4 128.28,465.4 97.55,217.1 178.63,441.2 222.53,675.3 l 7.1,37.6 c 14.2,45.7 -36,83.6 -72.79,54.9",
    style: {
      fill: "#fad6a5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14811.1,10846.2 7.2,-7.3 c 108.9,-111.1 234.7,-204.3 372.8,-276.1 v 0 0 c 89.9,260 154.8,528 193.8,800.3 l 1.8,12.4 c 9.3,39.6 66.8,36.2 72.3,-4.1 v 0 c 53.4,-237.7 84.8,-479.9 93.8,-723.4 l 2.7,-72.2 v 0 c 125.5,219.5 232.6,449 320.3,686.1 l 29.1,78.7 c 18.6,39.5 75.3,23.9 72.8,-19.9 v 0 c 18.5,-279.5 4.9,-560.2 -40.7,-836.6 l -11,-67.2 v 0 c 139.6,140.4 262.5,296.5 366.3,465.1 l 52.5,85.4 c 26.3,34.5 78.4,5.4 65.6,-36.5 l -20.2,-91.5 c -47.3,-214.3 -167.1,-915.3 -419.8,-1304.7 -127.5,-196.3 -382.5,-256.3 -489.2,-250.2 -154.1,8.8 -359.7,142.2 -454.2,304.2 0,0 -21,263.1 -102.3,475.8 -85.7,224 -154.3,454.3 -185,692.4 l -5,38.3 c -11.6,46.8 41,82 76.4,51",
    style: {
      fill: "#fad6a5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9711.59,9741.8 1.28,-6 c 30.14,-142 72.35,-476 -32.48,-476 -172.9,0 -517.16,6.1 -604.31,513.2 0,0 420.01,40.7 635.51,-31.2",
    style: {
      fill: "#bec4ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8774.22,9741.8 -1.28,-6 c -30.13,-142 -78,-279.7 -142.47,-409.8 v 0 c -10.4,-30.1 10.61,-61.9 42.4,-64 172.51,-11.5 649.72,3.9 736.86,511 0,0 -420,40.7 -635.51,-31.2",
    style: {
      fill: "#c6cecc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15993.4,9570.3 0.8,-6.4 c 19.5,-149.9 57.7,-296.8 113.8,-437.3 v 0 c 8.3,-32.1 -16.1,-63.3 -49.3,-62.9 -180.1,2.5 -674.2,58.2 -722.5,591.9 0,0 439.4,7.2 657.2,-85.3",
    style: {
      fill: "#bec4ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15020.2,9648.3 -1.8,-6.2 c -43.1,-144.9 -114.7,-488.1 -5.9,-496.8 179.5,-14.4 537.4,-36.7 670.1,482.5 0,0 -432.6,77.1 -662.4,20.5",
    style: {
      fill: "#c6cecc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21384.6,1033.1 H 3223.57 v 75.7 H 21384.6 v -75.7",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21384.6,0 H 3223.57 V 1033.1 H 21384.6 V 0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6613.67,16744.8 c 0,-132.7 -107.57,-240.3 -240.25,-240.3 -132.69,0 -240.26,107.6 -240.26,240.3 0,132.7 107.57,240.2 240.26,240.2 132.68,0 240.25,-107.5 240.25,-240.2",
    style: {
      fill: "#ff6c6e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9221.59,15242.3 h -405.65 v 405.6 h 405.65 v -405.6",
    style: {
      fill: "#29abe2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11056.8,17417.3 h -249.6 l -124.8,-216.1 124.8,-216.2 h 249.6 l 124.8,216.2 -124.8,216.1",
    style: {
      fill: "#fcee21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9564.28,12664.5 -439.9,439.9 574.64,134.7 z",
    style: {
      fill: "#8cc63f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22718.3,16104.8 c 23.4,130.7 148.2,217.6 278.8,194.3 130.6,-23.3 217.6,-148.1 194.3,-278.7 -23.4,-130.6 -148.2,-217.6 -278.8,-194.3 -130.6,23.3 -217.6,148.1 -194.3,278.7",
    style: {
      fill: "#ff6c6e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20415.1,18042.4 399.4,-71.3 -71.3,-399.4 -399.4,71.3 71.3,399.4",
    style: {
      fill: "#29abe2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18226.1,16223.8 245.7,-43.9 160.9,190.9 -84.9,234.7 -245.7,43.9 -160.8,-190.9 84.8,-234.7",
    style: {
      fill: "#fcee21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20530.9,20640.2 355.7,-510.3 -589.3,-31.7 z",
    style: {
      fill: "#8cc63f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1630.24,9922.7 c 0,-132.7 -107.56,-240.3 -240.25,-240.3 -132.69,0 -240.25,107.6 -240.25,240.3 0,132.7 107.56,240.2 240.25,240.2 132.69,0 240.25,-107.5 240.25,-240.2",
    style: {
      fill: "#fbb03b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4569.15,8937.1 H 4163.5 v 405.7 h 405.65 v -405.7",
    style: {
      fill: "#39b54a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3348.37,12100.1 h -249.59 l -124.79,-216.1 124.79,-216.2 h 249.59 l 124.79,216.2 -124.79,216.1",
    style: {
      fill: "#ff00ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2030.2,13667.5 -439.9,439.9 574.65,134.7 z",
    style: {
      fill: "#ff6753",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8977.7,20935.6 c 114.9,-66.4 261.84,-27 328.18,87.9 66.35,114.9 26.98,261.9 -87.94,328.2 -114.91,66.3 -261.84,27 -328.18,-87.9 -66.35,-114.9 -26.98,-261.9 87.94,-328.2",
    style: {
      fill: "#fbb03b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8361.77,17897.6 202.82,351.3 -351.3,202.9 -202.82,-351.3 351.3,-202.9",
    style: {
      fill: "#39b54a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6232.92,20536.3 124.8,216.2 h 249.59 l 124.79,-216.2 -124.79,-216.1 h -249.59 l -124.8,216.1",
    style: {
      fill: "#ff00ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5534.65,22461.6 -161.01,600.9 -404.01,-430.3 z",
    style: {
      fill: "#ff6753",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14117.6,18141.4 c 0,132.7 -107.6,240.3 -240.2,240.3 -132.7,0 -240.3,-107.6 -240.3,-240.3 0,-132.7 107.6,-240.2 240.3,-240.2 132.6,0 240.2,107.5 240.2,240.2",
    style: {
      fill: "#fbb03b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17056.5,19127 h -405.6 v -405.7 h 405.6 v 405.7",
    style: {
      fill: "#39b54a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15835.7,15964 h -249.6 l -124.8,216.1 124.8,216.2 h 249.6 l 124.8,-216.2 -124.8,-216.1",
    style: {
      fill: "#ff00ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14517.6,14396.7 -439.9,-439.9 574.6,-134.8 z",
    style: {
      fill: "#ff6753",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 21246.2,11643.7 c 0,-132.7 -107.6,-240.2 -240.3,-240.2 -132.6,0 -240.2,107.5 -240.2,240.2 0,132.7 107.6,240.3 240.2,240.3 132.7,0 240.3,-107.6 240.3,-240.3",
    style: {
      fill: "#8cc63f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 22151.5,8937.1 h -405.6 v 405.7 h 405.6 v -405.7",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 23354.3,12951.8 h -249.6 l -124.8,-216.1 124.8,-216.2 h 249.6 l 124.8,216.2 -124.8,216.1",
    style: {
      fill: "#935cab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19044.3,13667.5 -439.9,439.9 574.7,134.7 z",
    style: {
      fill: "#29abe2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13155.1,20819.4 c -74.5,-109.8 -45.9,-259.2 63.9,-333.7 109.8,-74.5 259.2,-45.9 333.7,63.9 74.5,109.7 45.9,259.1 -63.9,333.7 -109.7,74.5 -259.2,45.9 -333.7,-63.9",
    style: {
      fill: "#8cc63f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10885.9,19088.5 335.6,-227.8 227.9,335.6 -335.6,227.9 -227.9,-335.7",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12145.6,23085.7 206.5,-140.2 -18.1,-248.9 -224.7,-108.8 -206.5,140.2 18.2,248.9 224.6,108.8",
    style: {
      fill: "#935cab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16113.5,21257.2 611,116.9 -399.7,434.2 z",
    style: {
      fill: "#29abe2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3268.73,16930.9 c 0,132.7 107.56,240.3 240.25,240.3 132.68,0 240.25,-107.6 240.25,-240.3 0,-132.7 -107.57,-240.2 -240.25,-240.2 -132.69,0 -240.25,107.5 -240.25,240.2",
    style: {
      fill: "#8cc63f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2363.37,19637.5 h 405.66 v -405.6 h -405.66 v 405.6",
    style: {
      fill: "#ed1c24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1160.63,15622.8 h 249.59 l 124.79,216.2 -124.79,216.1 h -249.59 l -124.8,-216.1 124.8,-216.2",
    style: {
      fill: "#935cab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5470.59,14907.2 439.9,-439.9 -574.65,-134.8 z",
    style: {
      fill: "#29abe2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path156"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrateMembership);
export default __webpack_public_path__ + "static/media/celebrate_membership.d82e64fbc708a71e6499ce784c47bd75.svg";
export { ForwardRef as ReactComponent };